import * as BABYLON from "babylonjs";
import * as BABYLONGUI from "babylonjs-gui";
import VisualComponent from "./VisualComponent";
//import MediaManager from '@/api/MediaManager';

class Transition extends VisualComponent {
  getType() {
    return "Transition";
  }

  constructor({ id } = {}) {
    super({ id });
  }

  construct(context, prefab) {
    let situation;

    for (let i = 0; i < context.situations.length; i++)
      if (context.situations[i].id == prefab.getTargetID())
        situation = context.situations[i];

    //console.log(prefab)
    //console.log(prefab.automaticJump)
    if (prefab.automaticJump && prefab.automaticJump == "true") {
      //console.log("AUTOJUMP = true in Transition " + prefab.targetID)
      window.addEventListener("video_ended", (e) => {
        //console.log("Jumping to " + e.detail.id + " " + prefab.situation)
        if (e.detail.id == prefab.situation)
          context.$store.commit("handleGotoSituationTransition", {
            situationID: prefab.targetID,
          });
      });
    }

    super.setScaleFactor(0.2);
    const base = super.construct(context, prefab);

    var ease = new BABYLON.CubicEase();
    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEIN);

    this.mesh.actionManager = new BABYLON.ActionManager(this.scene);

    if (prefab.pickTrigger == "trackingShot") {
      this.mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(
          BABYLON.ActionManager.OnPickTrigger,
          () => {
            if (context.isGyrosActive) {
              window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
              context.$store.commit("handleGotoSituationTransition", {
                situationID: prefab.getTargetID(),
              });
            } else {
              window.dispatchEvent(new CustomEvent("hideTransitionPreview"));

              // Camera Rotation & Animation when leaving current room
              let camera = window.scene.activeCamera;
              let fps = 60;
              let duration = 1000;

              var clickedMeshPos = base.position;
              let unitVec = new BABYLON.Vector3(
                clickedMeshPos.x,
                0,
                clickedMeshPos.z
              ).normalize();
              var transitionEndPoint = camera.target.add(unitVec.scale(120));

              var coordinates = BABYLON.Vector3.Project(
                clickedMeshPos,
                BABYLON.Matrix.Identity(),
                window.scene.getTransformMatrix(),
                camera.viewport.toGlobal(
                  window.scene.getEngine().getRenderWidth(),
                  window.scene.getEngine().getRenderHeight()
                )
              );
              var vec_target_n = new BABYLON.Vector3(
                clickedMeshPos.x,
                0,
                clickedMeshPos.z
              );
              var vec_camDirection_n = camera.getForwardRay().direction;
              vec_camDirection_n.y = 0;
              var dotProduct =
                vec_target_n.x * vec_camDirection_n.x +
                vec_target_n.y * vec_camDirection_n.y +
                vec_target_n.z * vec_camDirection_n.z;
              var newAngle = Math.acos(
                dotProduct /
                  (vec_target_n.length() * vec_camDirection_n.length())
              );
              
              var newCamAlpha =
                coordinates.x > this.scene.getEngine().getRenderWidth() / 2
                  ? camera.alpha - newAngle
                  : camera.alpha + newAngle;

              setTimeout(() => {
                document.getElementById("renderCanvas").style.filter =
                  "blur(20px)";
                setTimeout(() => {
                  document.getElementById("renderCanvas").style.filter =
                    "blur(0px)";
                }, 400);
              }, duration - 300);

              BABYLON.Animation.CreateAndStartAnimation(
                "",
                camera,
                "alpha",
                fps,
                (duration / 1000) * fps,
                camera.alpha,
                newCamAlpha,
                0,
                ease
              );
              
              BABYLON.Animation.CreateAndStartAnimation(
                "",
                camera,
                "target",
                fps,
                (duration / 1000) * fps,
                camera.target,
                transitionEndPoint,
                0,
                ease
              );
              
              BABYLON.Animation.CreateAndStartAnimation(
                "",
                camera,
                "beta",
                fps,
                (duration / 1000) * fps,
                camera.beta,
                camera.beta,
                0,
                ease,
                function () {
                  context.$store.commit("handleGotoSituationTransition", {
                    situationID: prefab.getTargetID(),
                  });
                }
              );
            }
          }
        )
      );
    } else {
      this.mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(
          BABYLON.ActionManager.OnPickTrigger,
          () => {
            window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
            context.$store.commit("handleGotoSituationTransition", {
              situationID: prefab.getTargetID(),
            });
          }
        )
      );
    }
    // Hover-over animation
    if (prefab.outTrigger == "scale") {
      this.mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(
          BABYLON.ActionManager.OnPointerOutTrigger,
          () => {
            BABYLON.Animation.CreateAndStartAnimation(
              "",
              this.mesh,
              "scaling",
              30,
              10,
              this.mesh.scaling,
              new BABYLON.Vector3.One(),
              0,
              ease
            );

            if (
              prefab.getID() != "431641" &&
              prefab.getID() != "431651" &&
              prefab.getID() != 431641 &&
              prefab.getID() != 431651
            ) {
              //BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "visibility", 30,10, this.mesh.visibility, 0, 0, ease);
            }
            window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
          }
        )
      );
    }

    if (prefab.overTrigger == "scale") {
      this.mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(
          BABYLON.ActionManager.OnPointerOverTrigger,
          () => {
            BABYLON.Animation.CreateAndStartAnimation(
              "",
              this.mesh,
              "scaling",
              30,
              10,
              this.mesh.scaling,
              new BABYLON.Vector3.One().scale(1.1),
              0,
              ease
            );
            if (
              prefab.getID() != "431641" &&
              prefab.getID() != "431651" &&
              prefab.getID() != 431641 &&
              prefab.getID() != 431651
            ) {
              // BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "visibility", 30,10, this.mesh.visibility, 1, 0, ease);
            }
            /*
            window.dispatchEvent(new CustomEvent("showTransitionPreview",{detail:{
                url: context.publicPath + "/media/" +context.panoramaTour.getName()+ "/" + situation.name.trim() + "." + context.thumbnailType,
                name: situation.name,
            }}));
            */
          }
        )
      );
    }
    return base;
  }

  // createThumbnail(context,situation,base,prefab){
  //     //CREATE THUMBNAIL
  //     let texture = new BABYLON.Texture(context.publicPath + "/media/" +context.panoramaTour.getName()+ "/" + situation.name.trim() + ".jpg", window.scene);
  //     let name = "VisualComponentImage_"+prefab.getIconID();
  //     let thumbnail = BABYLON.MeshBuilder.CreatePlane(
  //         name,
  //         {
  //             width: 50,
  //             height: 25,
  //             sideOrientation: BABYLON.Mesh.DOUBLESIDE
  //         }, window.scene);
  //     let thumbnailMaterial = new BABYLON.StandardMaterial(name + "_material", window.scene);
  //     thumbnailMaterial.emissiveTexture = texture;
  //     thumbnailMaterial.emissiveTexture.uScale = -1;
  //     thumbnailMaterial.emissiveTexture.vScale = 1;
  //     thumbnailMaterial.disableLighting = true;
  //     thumbnailMaterial.opacityTexture = texture;
  //     thumbnailMaterial.opacityTexture.uScale = -1;
  //     thumbnailMaterial.opacityTexture.vScale = 1;
  //     thumbnailMaterial.emissiveTexture.hasAlpha = true;
  //     thumbnail.material = thumbnailMaterial;
  //     thumbnail.position.y = 30;
  //     thumbnail.position.z = -10;
  //     thumbnail.visibility = 0;

  //     //CREATE TEXT
  //     var plane = BABYLON.MeshBuilder.CreatePlane(
  //         "plane",{
  //             width: 60,
  //             height: 60,
  //             sideOrientation: BABYLON.Mesh.DOUBLESIDE
  //         },window.scene);
  //     plane.position.y = 40;
  //     plane.position.z = -15;
  //     plane.visibility = 0;

  //     var advancedTexture = BABYLONGUI.AdvancedDynamicTexture.CreateForMesh(plane);
  //     var text1 = new BABYLONGUI.TextBlock();
  //     text1.text = situation.name;
  //     text1.color = "white";
  //     text1.fontSize = 60;
  //     text1.drawOutline = true;
  //     text1.outlineColor = "black";
  //     text1.outlineWidth = 4;
  //     advancedTexture.addControl(text1);

  //     let thumbnailRoot = new BABYLON.TransformNode();
  //     thumbnailRoot.parent = base;
  //     this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){
  //         BABYLON.Animation.CreateAndStartAnimation("hide", thumbnail, "visibility", 10,2, 1, 0, 0)
  //         BABYLON.Animation.CreateAndStartAnimation("hide", plane, "visibility", 10, 2, 1, 0, 0)
  //     }));
  //     this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
  //         BABYLON.Animation.CreateAndStartAnimation("hide", thumbnail, "visibility", 10,2, 0, 1, 0)
  //         BABYLON.Animation.CreateAndStartAnimation("hide", plane, "visibility",10,2, 0, 1, 0)
  //     }));

  //     thumbnail.parent = thumbnailRoot;
  //     plane.parent = thumbnailRoot;
  // }
}

export default Transition;
